export interface IUom {
  id: string;
  name: string;
}

export interface IUomConversion {
  id: number;
  part: string;
  manufacturerId: number;
  fromUom: string;
  fromUomId: number;
  toUom: string;
  multiplier: number;
}
export class UpsertUomConversionForm {
  part: string;
  manufacturerId: number;
  fromUom: IUom;
  toUom: string;
  multiplier: number;
}

export class UpsertCorporatePartUomForm {
  uom: IUom;
  purchaseCostUom: string;
  salesUom: string;
  alternateSalesUom: string;
  packageUom: string;
  externalUom: string;
  alternateUom: string;
}
